module.exports = __webpack_public_path__ + "img/protected-bag-icon-6.ab504481.svg";